module.exports = __webpack_public_path__ + "media/images/member-portal-373759c5f99d0ded00c9b3e881e1e6fb.svg";